import { runInAction } from 'mobx'
import { cloneDeep } from 'lodash'

import { http, storage, timer } from 'utils'
import { config } from 'config'

import BaseStore from './BaseStore'

const original = {
  consent_id: null,
  ver: '',
  status: 'active',
  short_content: '',
  content: '',
}

const Url = `${config.api}/v1/public/account/consent`
let state
export class Consent extends BaseStore {
  constructor() {
    super()
    this.observable({
      privacy: cloneDeep(original),
      terms: cloneDeep(original),
      cookie: cloneDeep(original),
      current: {
        cookie: {},
      },
    })
    state = this
  }

  async getPrivacy() {
    const url = `${Url}/privacy`
    const resp = await http.get(url)

    const data = resp.body || {}

    const tmp = data.consent_id ? data : cloneDeep(original)
    runInAction(() => {
      state.privacy = tmp
    })
  }

  async getTerms() {
    const url = `${Url}/terms`
    const resp = await http.get(url)

    const data = resp.body || {}
    const tmp = data.consent_id ? data : cloneDeep(original)

    runInAction(() => {
      state.terms = tmp
    })
  }

  async getCookie() {
    const url = `${Url}/cookie`
    const resp = await http.get(url)

    const data = resp.body || {}
    const tmp = data.consent_id ? data : cloneDeep(original)

    runInAction(() => {
      state.cookie = tmp
    })
  }

  async loadCookie() {
    const data = storage.load('cookie') || {}
    const { consent_id, status } = data

    let updated_at
    if (status === 'close' && data.updated_at) {
      const now = timer.get()
      updated_at = timer.get(data.updated_at)

      const days = now.diff(updated_at, 'days')
      if (days >= 1) {
        return
      }
    }

    runInAction(() => {
      state.current.cookie = { consent_id, status }
    })
  }

  async acceptCookie(consent_id = 0, status) {
    const updated_at = timer.get().toISOString()
    const data = { consent_id, status, updated_at }
    await storage.save('cookie', data)

    runInAction(() => {
      state.current.cookie = data
    })
  }
}

export default new Consent()
